import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    cardSliderContainer: {
        marginTop: '0px',
        overflowY: 'hidden',
        marginLeft: '-24px',
        marginRight: '-24px',
        '@media (min-width: 1128px)': {
            marginLeft: '-8px',
            marginRight: '-8px',
            overflow: 'hidden'
        }
    },
    cardSlider: {
        transition: '-ms-transform 0.5s,-webkit-transform 0.5s,transform 0.5s',
        whiteSpace: 'nowrap',
        overflowX: 'auto',
        overflowY: 'hidden',
        padding: '0 18px',
        marginBottom: '-30px'
    },
    cardSlider_enableCarouselMd: {
        '@media (min-width: 744px)': {
            padding: '0 16px'
        }
    },
    cardSlider_enableCarouselLg: {
        '@media (min-width: 1128px)': {
            marginBottom: '0px',
            padding: '0px',
            overflow: 'visible'
        }
    },
    cardSlider_disableSliderXs: {
        '@media (max-width: 743px)': {
            marginBottom: '0px',
            padding: '0 16px',
            overflow: 'visible',
            whiteSpace: 'normal',
            marginTop: '0px'
        }
    },
    cardSlider_disableSliderSm: {
        '@media (max-width: 1128px)': {
            marginBottom: '0px',
            padding: '0 16px',
            overflow: 'visible',
            whiteSpace: 'normal',
            marginTop: '0px'
        }
    },
    cardSlider_disableSliderMd: {
        '@media (min-width: 1128px)': {
            marginBottom: '0px',
            padding: '0px',
            overflow: 'visible',
            whiteSpace: 'normal',
            marginTop: '0px'
        }
    },
    cardSlider_disableSliderLg: {
        '@media (min-width: 1128px)': {
            marginBottom: '0px',
            padding: '0px',
            overflow: 'visible',
            whiteSpace: 'normal',
            marginTop: '0px'
        }
    },
    responsiveColumn_normal: {
        display: 'inline-block',
        verticalAlign: 'top',
        whiteSpace: 'normal',
        '@media (min-width: 1548px)': {
            width: '20%'
        },
        '@media (min-width: 1248px) and (max-width: 1547px)': {
            width: '25%'
        },
        '@media (min-width: 948px) and (max-width: 1247px)': {
            width: '33.333333333333336%'
        },
        '@media (min-width: 648px) and (max-width: 947px)': {
            width: '50%'
        },
        '@media (max-width: 647px)': {
            width: '66.6667%'
        }
    },
    responsiveColumn_search: {
        display: 'inline-block',
        verticalAlign: 'top',
        whiteSpace: 'normal',
        width: '100%',
        '@media (min-width: 1440px)': {
            width: '33.333333333333336%'
        },
        '@media (min-width: 1128px) and (max-width: 1439px)': {
            width: '50%'
        },
        '@media (min-width: 744px) and (max-width: 1127px)': {
            width: '50%'
        }
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/styles.js